import { useZakelijkOrder } from "app/hooks/payment/useZakelijkOrder";
import { DELIVERY_PRICES } from "shared/config/pricing";
import Text from "shared/ui/typography/Text";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";

const ZakelijkPaymentPriceTable = () => {
  const { subTotal, totalZakelijkDiscount } = useZakelijkOrder();
  const formattedSubTotal = getFormattedPrice(subTotal);

  const showZakelijkDiscounts = totalZakelijkDiscount > 0;

  const zakelijkDeliveryCostFormatted = getFormattedPrice(
    DELIVERY_PRICES.ZAKELIJK,
  );

  return (
    <div className="gg-mb-5 gg-grid gg-grid-cols-12 lg:gg-flex lg:gg-gap-x-11">
      <div className="gg-col-span-9 gg-grid gg-gap-y-2.5 sm:gg-col-span-6">
        <Text>Subtotaal</Text>

        <Text>Bezorgkosten</Text>

        <Text>Korting zakelijk </Text>
      </div>
      <div className="gg-col-span-3 gg-grid gg-gap-y-2.5 gg-justify-self-end gg-text-right sm:gg-col-span-6 sm:gg-col-start-7 lg:gg-pl-0 lg:gg-text-right">
        <Text data-testid="subtotal-price" bold>
          {formattedSubTotal}
        </Text>

        <Text bold>{zakelijkDeliveryCostFormatted}</Text>

        {showZakelijkDiscounts && (
          <Text bold className="gg-text-green-300">
            - {getFormattedPrice(totalZakelijkDiscount)}
          </Text>
        )}
      </div>
    </div>
  );
};
export default ZakelijkPaymentPriceTable;
